import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private cookieService: CookieService,
  ) { }

  errorCode: string = '';
  errorMessage: string = '';
  expires: Date | number = 0.3; // 8 hours

  get tosApplied(): boolean {
    return localStorage.getItem('tos') === 'true';
  }

  set tosApplied(value: boolean) {
    localStorage.setItem('tos', value.toString());
  }

  get userToken(): string | null {
    return this.cookieService.get('bearer') || null;
  }

  set userToken(token: string | null) {
    this.cookieService.set('bearer', token || '', { expires: this.expires });
  }

  set expirationDate(date: Date | number) {
    this.expires = date;
  }
}
